import React from 'react';

function useQuery() {
  const data = location;

  return React.useMemo(() => new URLSearchParams(data.search), [data.search]);
}

export default useQuery;
